import React from 'react'
import {HashRouter as Routes, Switch, Route,} from 'react-router-dom'
import Tenants from "Components/templates/Tenants";
import TenantCreate from "Components/templates/TenantCreate"
import Login from "Components/templates/Login";
import TenantEdit from "Screens/TenantEdit";
import TenantView from "Screens/TenantView";
import CodeFlagsBulk from "Screens/CodeFlagsBulk";
import {AppProviders} from 'Context'
import {GlobalStyles} from "Styles/global-styles";
import 'antd/dist/antd.css';
import {getToken} from "./Utils/loginUtil";

function AppRoutes() {
    return (
        <Switch>
            <Route exact path="/management" component={Tenants} />
            <Route exact path="/management/tenant/create" component={TenantCreate} />
            <Route exact path="/management/code-flags" component={CodeFlagsBulk} />
            <Route exact path="/management/tenant/:identifier/:branch/view/" component={TenantView} />
            <Route exact path="/management/tenant/:identifier/:branch/edit" component={TenantEdit} />
            <Route path="/" component={Tenants} />
        </Switch>
    );
}

function App() {
    const renderApp = () => {
        if (!getToken()) return <Login />;
        return <AppRoutes />;
    };

    return (
        <AppProviders>
            <GlobalStyles />
            {renderApp()}
        </AppProviders>
    );
}

export default App;
